import { __rest } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import { Box } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

var useBoxedIconStyle = makeStyles()((theme, { variant = 'neutral' }) => {
    const variantBackbroundMapping = {
        success: theme.palette.success.main,
        warning: theme.palette.warning.main,
        error: theme.palette.error.main,
        neutral: theme.palette.grey[200],
    };
    return {
        container: {
            borderRadius: '8px',
            width: '36px',
            height: '36px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: variantBackbroundMapping[variant],
        },
    };
});

const BoxedIcon = (_a) => {
    var { icon, variant = 'neutral', className } = _a, rest = __rest(_a, ["icon", "variant", "className"]);
    const { classes } = useBoxedIconStyle({ variant });
    return (jsx(Box, Object.assign({ className: `${classes.container} ${className !== null && className !== void 0 ? className : ''}` }, rest, { children: icon })));
};

export { BoxedIcon as B };
//# sourceMappingURL=BoxedIcon-cf923779.js.map
